import React from 'react';

import { useTranslation } from 'react-i18next';
import { REGEX_PASSWORD } from 'constants/regex';

import CustomFormItem from 'styles/formStyled';
import CustomInputPassword from 'styles/inputPasswordStyled';
import { PasswordForm } from './styled';

const PasswordItem = (props: any) => {
  const { formData, isChangePassword } = props;
  const { t } = useTranslation(['auth', 'validation']);

  return (
    <PasswordForm form={formData} layout="vertical">
      {isChangePassword && (
        <CustomFormItem
          label={t('auth:password.your_current_password')}
          required={true}
          name="oldPass"
          rules={[
            {
              required: true,
              message: `${t('validation:required', {
                field: t('auth:password.your_current_password'),
              })}`,
            },
          ]}
        >
          <CustomInputPassword placeholder={t('auth:password.your_current_password_placeholder')} />
        </CustomFormItem>
      )}
      <CustomFormItem
        label={t('auth:password.new_password')}
        required={true}
        name="newPass"
        rules={[
          {
            required: true,
            message: `${t('validation:required', {
              field: t('auth:password.new_password'),
            })}`,
          },
          {
            pattern: new RegExp(REGEX_PASSWORD),
            message: `${t('validation:password_invalid')}`,
          },
          {
            min: 6,
            message: `${t('validation:min', {
              field: t('auth:get_started.password'),
              min: '6',
            })}`,
          },
        ]}
      >
        <CustomInputPassword placeholder={t('auth:password.new_password_placeholder')} />
      </CustomFormItem>
      <CustomFormItem
        label={t('auth:password.confirm_new_password')}
        required={true}
        name="confPass"
        dependencies={['newPass']}
        rules={[
          {
            required: true,
            message: `${t('validation:required', {
              field: t('auth:password.confirm_new_password'),
            })}`,
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('newPass') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('The two passwords that you entered do not match!'));
            },
          }),
        ]}
      >
        <CustomInputPassword placeholder={t('auth:password.confirm_new_password_placeholder')} />
      </CustomFormItem>
    </PasswordForm>
  );
};

export default PasswordItem;
